<template lang="pug">
//- template(#item="{ result, openInNewWindow, formatDate }")
.search__results(v-if="results.length > 0")
    //- this is a little odd but i cant think of a better way to handle toggling this without completely messing with the computed resultsbyCategory function in a hard to follow way
    template(v-if="!showIndividual")
        VideoLibraryDashboard(:data="dashboardData" :categories="activeFilters && activeFilters.categories")
    template(v-else)
        .video-library-search-content__item.search-submitted
            template(v-for="result in results")
                slot(
                    name="item",
                    :result="result",
                    :openInNewWindow="options.openInNewWindow",
                    :formatDate="formatDate",
                    :searchSubmitted="searchSubmitted"
                )
                    Item(:result="result", :openInNewWindow="options.openInNewWindow", :formatDate="formatDate", :searchSubmitted="searchSubmitted" :showPlaylist="true")
                
p.search__results-empty(v-else v-html="options.noResultsText")
</template>

<script>
import VideoLibraryDashboard from "./videoLibraryDashboard.vue";
import Item from "./Item.vue";
import { format } from "date-fns";

export default {
    name: "VideoLibraryResults",
    components: { Item, VideoLibraryDashboard },
    props: ['searchSubmitted', 'hasFilters', 'activeFilters'],
    data() {
        return {
        };
    },
    computed: {
        results() {
            return this.$store.getters.results.itemResults;
        },
        dashboardData() {
            return this.$store.getters.results.dashboardData
        },
        reloading() {
            if (this.options.transitionOnReload) return this.$store.getters.reloading;
            else return false
        },
        showIndividual() {
            const onlyCategoryFilter = this.hasFilters && this.activeFilters && this.activeFilters.categories?.length && !this.activeFilters.levels?.length && !this.activeFilters.types?.length;
            return this.searchSubmitted || (this.hasFilters && !onlyCategoryFilter);
        },
        // non-bluesearch
        resultsByCategory() {
            return this.results.reduce((acc, result) => {
                result.meta.videocategories.forEach(category => {
                    if (!acc[category.name]) {
                        acc[category.name] = []
                    }
                    acc[category.name].push(result)
                })
                return acc
            }, {})
        },
        resultsByCategoryKeys() {
            return Object.keys(this.resultsByCategory)
        }
    },
    methods: {
        formatDate(date, formatPattern) {
            return format(new Date(date), formatPattern);
        },
        getElTop() {
            let elem = this.$root.$el;
            let distance = 0;
            do {
            distance += elem.offsetTop;
            elem = elem.offsetParent;
            } while (elem);
            distance = distance < 0 ? 0 : distance;
            return distance;
        },
        scrollToTop() {
            if (this.options.scrollOnReload) window.scrollTo({ top: this.getElTop(), behavior: "smooth" });
        },
        // non-bluesearch
    },
    watch: {
        reloading() {
            this.scrollToTop();
        },
    },
    mounted() {
        // this.getVideoCategories()
        // this.initSwiper()
    }
};
</script>

<style lang="scss" scoped>
span.root {
    display: contents;
}
.search__results {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    &-empty {
    font-style: italic;
    margin: 2rem;
    text-align: center;
    }
}
.search-submitted {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 1.875rem;

    @include mq(md) { 
        grid-template-columns: repeat(2, 1fr);
    }

    @include mq(lg) {  
        grid-template-columns: repeat(3, 1fr);
    }
}
</style>